var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'shown' : _vm.show},attrs:{"id":"scanInput"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.scan),expression:"scan"}],ref:"scannerInput",attrs:{"type":"text"},domProps:{"value":(_vm.scan)},on:{"change":_vm.checkEan,"input":function($event){if($event.target.composing)return;_vm.scan=$event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }